import { render, staticRenderFns } from "./PartnerCode.vue?vue&type=template&id=c201db9a&"
import script from "./PartnerCode.vue?vue&type=script&lang=js&"
export * from "./PartnerCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports